import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=314e92d1&scoped=true&"
import script from "./invitation.vue?vue&type=script&lang=js&"
export * from "./invitation.vue?vue&type=script&lang=js&"
import style0 from "./invitation.vue?vue&type=style&index=0&id=314e92d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314e92d1",
  null
  
)

export default component.exports